<div class="modal fade" bsModal tabindex="-1" role="dialog" aria-hidden="true" #htmlcontentmodal="bs-modal">
    <div class="modal-dialog  modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-primary text-white">
                <p class="modal-title h3">
                    <strong>Current live content</strong>
                </p>
                <button type="button" class="btn btn-sm btn-primary" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true"><i class="fa fa-close"></i></span>
                </button>
            </div>
            <div class="modal-body modal-border">
                <div class="row">
                    <div class="col">
                        <ng-container *ngIf="originalItem && originalItem.value.length > 0">
                            <p class="text-muted mb-0" [innerHTML]="originalItem.value"></p>
                            <p *ngIf="originalItem.metadataItemDetails.length > 0" class="text-muted mb-0">
                                <small>
                                    <strong>Source:</strong>
                                    <ng-container *ngFor="let metadataItem of originalItem.metadataItemDetails; let i = index">
                                        <span>
                                            <a *ngIf="metadataItem.url" href="{{metadataItem.url}}" title="{{metadataItem.url}}" target="_blank">{{metadataItem.name}} - </a>
                                            <ng-container *ngIf="!metadataItem.url">{{metadataItem.name}}</ng-container>
                                        </span>
                                        {{metadataItem.value}}.
                                    </ng-container>
                                </small>
                            </p>
                        </ng-container>
                        <p class="text-muted mb-0" *ngIf="!originalItem || (originalItem && originalItem.value.length == 0)">There is currently no content live</p>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>